import { Status } from '../../../../../../shared/dependenciesV2';
import type { BuildWithTask, DependencyIssue, DependencyState } from '../../../../../../shared/dependenciesV2';
import type { TaskStatus } from '../../../../../../shared/model-typings';

/**
 * Get Status value from api provided StatusState response
 * @param {DependencyState} status from api
 * @returns {Status} Status value
 */
export const getStatusFromDependencyState = (status: DependencyState) => {
  if (status.resolved && !status.analyzing) {
    return Status.Analyzed;
  }

  if (status.analyzing) {
    return Status.InProgress;
  }

  if (status.error) {
    return Status.Failed;
  }

  if (status.unsupported || !status.resolved) {
    return Status.Unknown;
  }

  return Status.Unknown;
};

const isBuildRunning = (status: TaskStatus) => ['CREATED', 'ASSIGNED', 'RUNNING'].includes(status);

export const getIsAnalyzing = (builds: BuildWithTask[]) =>
  builds?.some(build => isBuildRunning(build?.task?.status || 'CREATED'));

/**
 * Returns whether the dependency is blocked by a quality blocked policy
 *
 * @param {DependencyIssue} issues on the dependency
 * @returns {boolean} true if the dependency is blocked
 */
export const isDependencyBlocked = (issues: DependencyIssue[]): boolean =>
  !!issues.find((issue) => issue.type === 'blacklisted_dependency');

export const isIssueOfActiveType = (issue: DependencyIssue, validIssueTypes: Readonly<string[]>) =>
  issue.status === 'active' && validIssueTypes.includes(issue.type);
